/**
 * Central brand configuration for Belomotors.
 *
 * BDC phone (the concierge team that handles all customer contact) is
 * surfaced across the site: header, footer, appointment modal, vehicle
 * detail page and public dealer profile.
 *
 * As of Phase 6, the actual live Twilio number comes from
 * GET /api/public/config (see `useBrandConfig` hook). These string exports
 * remain the pre-hydration fallback values used before the config fetch
 * resolves — always visually correct for the first paint.
 */

export const BDC_PHONE_DISPLAY = "(978) 450-8275";

/** RFC-3966 tel: URI. Includes country code so mobile browsers dial correctly. */
export const BDC_PHONE_HREF = "tel:+19784508275";

/** Human-friendly alias kept for backwards-compat with earlier drafts. */
export const BDC_PHONE = BDC_PHONE_DISPLAY;

/** Belomotors brand colors — kept here so JS surfaces (charts, SVGs) stay in sync with CSS vars. */
export const BRAND_BLUE = "#1B3A6B";
export const BRAND_GOLD = "#D4A537";

const brand = {
  BDC_PHONE,
  BDC_PHONE_DISPLAY,
  BDC_PHONE_HREF,
  BRAND_BLUE,
  BRAND_GOLD,
};

export default brand;
